import {ContentDraftColumnData} from 'common/src/modules/contentFeeds/contentFeeds.types';

/**
 * Maps simple string values from the tool to ContentDraftColumnData (value field).
 */
function normalizeDraftColumnValues(
  raw: Record<string, string> | null | undefined,
  existingByColumn?: Record<string, ContentDraftColumnData> | null,
): Record<string, ContentDraftColumnData> | undefined {
  if (!raw || Object.keys(raw).length === 0) {
    return undefined;
  }

  const result: Record<string, ContentDraftColumnData> = {};

  for (const key of Object.keys(raw)) {
    const v = raw[key];
    const prev = existingByColumn?.[key];

    result[key] = {
      ...prev,
      value: v,
    };
  }

  return result;
}

export default normalizeDraftColumnValues;
